import { render, staticRenderFns } from "./review_tab_info.vue?vue&type=template&id=e83eb1da&scoped=true&"
import script from "./review_tab_info.vue?vue&type=script&lang=js&"
export * from "./review_tab_info.vue?vue&type=script&lang=js&"
import style0 from "./review_tab_info.vue?vue&type=style&index=0&id=e83eb1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83eb1da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e83eb1da')) {
      api.createRecord('e83eb1da', component.options)
    } else {
      api.reload('e83eb1da', component.options)
    }
    module.hot.accept("./review_tab_info.vue?vue&type=template&id=e83eb1da&scoped=true&", function () {
      api.rerender('e83eb1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/reviews/item/tabs/review_tab_info.vue"
export default component.exports